import { Currencies } from '@constants/enums';
import { RoleId, RoleIds } from '@efexteam/permission-manager';
import { Country } from '../../../configs/language';
import { COUNTRY_FLAG_ICON } from '../../../configs/language/config';
import { SelectOption } from '../types';

export const CURRENCY_ICON = {
  USD: COUNTRY_FLAG_ICON.USD,
  MXN: COUNTRY_FLAG_ICON.MXN,
  COP: COUNTRY_FLAG_ICON.COP,
  EUR: COUNTRY_FLAG_ICON.EUR,
  GBP: COUNTRY_FLAG_ICON.GBP,
  CAD: COUNTRY_FLAG_ICON.CAD,
  HKD: COUNTRY_FLAG_ICON.HKD,
  JPY: COUNTRY_FLAG_ICON.JPY,
  CHF: COUNTRY_FLAG_ICON.CHF,
};

export const COUNTRIES_OPTIONS: SelectOption[] = [
  {
    id: 'usa',
    value: 'USA',
    icon: COUNTRY_FLAG_ICON.USD,
  },
  {
    id: 'mx',
    value: 'MX',
    icon: COUNTRY_FLAG_ICON.MXN,
  },
  {
    id: 'col',
    value: 'COL',
    icon: COUNTRY_FLAG_ICON.COP,
  },
  {
    id: 'eur',
    value: 'EUR',
    icon: COUNTRY_FLAG_ICON.EUR,
  },
  {
    id: 'gbp',
    value: 'GBP',
    icon: COUNTRY_FLAG_ICON.GBP,
  },
];

export const CURRENCY_OPTIONS: SelectOption[] = [
  {
    id: 'USD',
    value: 'USD',
    icon: COUNTRY_FLAG_ICON.USD,
  },
  {
    id: 'MXN',
    value: 'MXN',
    icon: COUNTRY_FLAG_ICON.MXN,
  },
  {
    id: 'COP',
    value: 'COP',
    icon: COUNTRY_FLAG_ICON.COP,
  },
  {
    id: 'EUR',
    value: 'EUR',
    icon: COUNTRY_FLAG_ICON.EUR,
  },
  {
    id: 'GBP',
    value: 'GBP',
    icon: COUNTRY_FLAG_ICON.GBP,
  },
  {
    id: 'CAD',
    value: 'CAD',
    icon: COUNTRY_FLAG_ICON.CAD,
  },
  {
    id: 'HKD',
    value: 'HKD',
    icon: COUNTRY_FLAG_ICON.HKD,
  },
  {
    id: 'JPY',
    value: 'JPY',
    active: false,
    icon: COUNTRY_FLAG_ICON.JPY,
  },
  {
    id: 'CHF',
    value: 'CHF',
    active: false,
    icon: COUNTRY_FLAG_ICON.CHF,
  },
  {
    id: 'BRL',
    value: 'BRL',
    active: false,
    icon: COUNTRY_FLAG_ICON.BRL,
  },
];

export const COUNTRY_CURRENCY = {
  USA: Currencies.USD,
  US: Currencies.USD,
  MX: Currencies.MXN,
  COL: Currencies.COP,
};

export enum CurrencyCountry {
  USD = 'USA',
  MXN = 'MX',
  COP = 'COL',
}

export enum CountryCodes {
  USA = 'USA',
  MX = 'MX',
  COL = 'COL',
}

export type Currency = (typeof COUNTRY_CURRENCY)[keyof typeof COUNTRY_CURRENCY];

export const DROPDOWN_OPTIONS_COUNTRY: { key: string; value: Country }[] = [
  { key: 'Mexico', value: 'MX' },
  { key: 'United States', value: 'USA' },
  { key: 'Colombia', value: 'COL' },
];

export const DROPDOWN_OPTIONS_USER_ROLE: { key: string; value: RoleId }[] = [
  { key: 'Owner', value: 1 },
  { key: 'Payment Approver', value: RoleIds.PAYMENT_APPROVER },
  { key: 'Payment Analyst', value: RoleIds.PAYMENT_ANALYST },
  { key: 'Read Only', value: RoleIds.READ_ONLY },
];

export enum EnterpriseRate {
  NORMAL = 1,
  CORPORATE = 2,
  COMPANY_GROWING = 3,
}

export const DROPDOWN_OPTIONS_ENTERPRISE_SPREAD: {
  key: string;
  value: EnterpriseRate;
}[] = [
  { key: 'Normal', value: EnterpriseRate.NORMAL },
  { key: 'Corporate Efex', value: EnterpriseRate.CORPORATE },
  { key: 'Company Growing', value: EnterpriseRate.COMPANY_GROWING },
];

enum AccountType {
  SAVING = 'SAVING',
  CHECKING = 'CHECKING',
}

export const DROPDOWN_OPTIONS_ACCOUNT_TYPE: {
  key: string;
  value: AccountType;
}[] = [
  { key: 'Checking', value: AccountType.CHECKING },
  { key: 'Saving', value: AccountType.SAVING },
];

export enum AddFundsPendingStatus {
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
}

export const DROPDOWN_OPTIONS_ADD_FUNDS_PENDING: {
  key: string;
  value: AddFundsPendingStatus;
}[] = [
  { key: 'PROCESSING', value: AddFundsPendingStatus.PROCESSING },
  { key: 'COMPLETED', value: AddFundsPendingStatus.COMPLETED },
];

export enum EntityBusiness {
  COMPANY = 'COMPANY',
  PERSON = 'PERSON',
}

export const DROPDOWN_OPTIONS_ENTITY_TYPE: {
  key: string;
  value: EntityBusiness;
}[] = [
  { key: 'COMPANY', value: EntityBusiness.COMPANY },
  { key: 'PERSON', value: EntityBusiness.PERSON },
];

export const PAYMENTS_AMOUNT_OPTIONS: SelectOption[] = [
  {
    id: '1',
    value: '$50,000.00 - $100,000.00',
  },
  {
    id: '2',
    value: '$100,000.00 - $500,000.00',
  },
  {
    id: '3',
    value: '$500,000.00 - $1,000,000.00',
  },
  {
    id: '4',
    value: 'operationNumber',
  },
];

export const REGISTER_MONTLHY_RECIPIENTS_OPTIONS: SelectOption[] = [
  {
    id: '1',
    value: 'accNumber1',
  },
  {
    id: '2',
    value: 'accNumber2',
  },
  {
    id: '3',
    value: 'accNumber3',
  },
  {
    id: '4',
    value: 'accNumber4',
  },
];

export const PAYMENTS_FREQUENCY_OPTIONS_TRANSACTIONAL: SelectOption[] = [
  {
    id: '1',
    value: 'tpIncome1',
  },
  {
    id: '2',
    value: 'tpIncome2',
  },
  {
    id: '3',
    value: 'tpIncome3',
  },
  {
    id: '4',
    value: 'tpIncome4',
  },
];

export const EFEX_NAME = 'EFEX';
export const SWIFT_NAME = 'SWIFT';
export const LOCAL_LABEL = 'Local';
export const SWIFT_LABEL = 'SWIFT';

export const EFEX_PRODUCTS_OPTIONS: SelectOption[] = [
  {
    id: '1',
    value: 'tpProducts1',
  },
  {
    id: '2',
    value: 'tpProducts2',
  },
  {
    id: '3',
    value: 'tpProducts3',
  },
  {
    id: '4',
    value: 'tpProducts4',
  },
  {
    id: '5',
    value: 'tpProducts5',
  },
  {
    id: '6',
    value: 'tpProducts6',
  },
  {
    id: '7',
    value: 'tpProducts7',
  },
  {
    id: '8',
    value: 'tpProducts8',
  },
  {
    id: '9',
    value: 'tpProducts9',
  },
];

export const FUNDS_SOURCE_OPTIONS: SelectOption[] = [
  {
    id: '1',
    value: 'tpFundsSource1',
  },
  {
    id: '2',
    value: 'tpFundsSource2',
  },
  {
    id: '3',
    value: 'tpFundsSource3',
  },
  {
    id: '4',
    value: 'tpFundsSource4',
  },
  {
    id: '5',
    value: 'tpFundsSource5',
  },
  {
    id: '6',
    value: 'tpFundsSource6',
  },
  {
    id: '7',
    value: 'tpFundsSource7',
  },
];
